import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1263. 以降のプロジェクト（売上）一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/next_sales_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const nextSalesOrders = (props: Props): Promise<SalesOrderOutline[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/next_sales_orders`
  );
};

export const useNextSalesOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => nextSalesOrders(props),
  });
};

export const useInvalidateNextSalesOrders = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) }).then((r) => {});
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'next_sales_orders'];
};
